<div class="service-container" [mmTestId]="'ORDER_HISTORY.ORDER_LINE_VAS_ITEM'">
  <div class="service-content__link-title">
    <app-link-ga-tracking [toolTip]="orderLine?.referenceProduct?.name" [linkType]="'link-service'"
      [redirectLink]="'/' + APP_PRODUCT_ROUTE + '/' + orderLine?.referenceProduct?.productId" [label]="orderLine?.referenceProduct?.name"
      [serviceInstallationLink] = "orderLine?.product?.name">
    </app-link-ga-tracking>
  </div>
  <div class="service-content" [class.service-content--divider]="!isLastOrderLine">
    <div class="service-content__info-block">
      <div>
        <div class="service-content__img-wrapper">
          <app-link-ga-tracking [linkType]="'img'" [imageSource]="settingIconUrl"
            [redirectLink]="'/' + APP_PRODUCT_ROUTE + '/' + orderLine?.referenceProduct?.productId"
            [label]="orderLine?.referenceProduct?.name">
          </app-link-ga-tracking>
        </div>
        <p [mmTestTarget]="'order-line-service-seller-name'">
          {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SOLD_BY' | translate }}:
          <a [routerLink]="[sellerRoute, orderLine?.seller?.id]" (click)="navigateToSellerClicked()">
            {{ orderLine?.seller?.shopName }}
          </a>
        </p>
      </div>
      <div class="service-content__delivery-section">
        <div class="service-content__pps">
          <div class="mr-gutter-xs">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAS.PRODUCT_PPS' | translate }}:</div>
          <div>
            <span [mmTestTarget]="'order-line-service-quantity'">{{ orderLine?.quantity }}</span>
            X
            <span [mmTestTarget]="'order-line-service-unit-price'">{{ unitPrice?.amount | currency : unitPrice?.currency
              }}</span>
            <span class="vat"> {{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="service-content__info-block service-content__info-block--finance-section">
      <ng-container>
        <div class="service-content__finance-section_rows">
          <div class="service-content__finance-row">
            <div>
              {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
              <span class="vat">{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRICE" | translate: {exclude: isEntrepreneur} }}</span>
            </div>
            <div [mmTestTarget]="'order-line-service-subtotal-price'">
              {{ price?.amount | currency : price?.currency }}
            </div>
          </div>
          <div *ngIf="isEntrepreneur">
            <div class="service-content__finance-row">
              <div>
                {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
                <span class="vat">{{ 'CART.TOTALS.TOTAL.VAT_INCL' | translate }}</span>
              </div>
              <div [mmTestTarget]="'order-line-service-subtotal-vat-price'">
                {{ totalPriceGross?.amount | currency : totalPriceGross?.currency }}
              </div>
            </div>
          </div>
          <div *ngIf="isDiscountApplied">
            <div class="service-content__finance-row">
              <div>
                <strong>{{ "PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_DISCOUNT" | translate }}</strong>
                <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INCL" | translate }}</span>
              </div>
              <div [mmTestTarget]="'order-line-service-discount'">
                <strong>-{{ discount?.amount | currency : discount?.currency }}</strong>
              </div>
            </div>
            <div class="service-content__finance-row discount-applied">
              <div>
                <strong>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}</strong>
                <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INCL" | translate }}</span>
              </div>
              <div [mmTestTarget]="'order-line-service-total-price'">
                <strong>{{ grandTotal?.amount | currency : grandTotal?.currency }}</strong>
              </div>
            </div>
          </div>
          <div *ngIf="!isDiscountApplied && !isEntrepreneur" class="service-content__finance-row">
            <div>
              {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.PRODUCT_TOTAL_PRICE' | translate }}
              <span class="vat"> {{ "CART.TOTALS.TOTAL.VAT_INCL" | translate }}</span>
            </div>
            <div [mmTestTarget]="'order-line-service-subtotal-price'">
              {{ grandTotal?.amount | currency : grandTotal?.currency }}
            </div>
          </div>
        </div>
        <div class="service-content__contact-section">
          <button mm-button class="contact-button" [color]="'secondary'"
            (click)="createSupportTicket(orderLine?.orderLineId)">
            {{ 'ORDER_HISTORY.ORDER_LINE.VAS.CONTACT_SELLER' | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>